import React from "react";
import { Card } from "react-bootstrap";
import { tabHeadingDictionary as tabKeywords } from "@core/global/global-country-dictionary";
import AnalyticsImg from "@assets/images/analytics.svg";
import Reports from "@shared/Reports";
import UpgradeIcon from "@assets/images/Solid_Status_Lightning-alt.svg";

const Report = (props) => {
  return (
    <div>
      <div className={props.currentTab === tabKeywords.reports ? "tab-pane fade show active" : "tab-pane fade"} id="nav-summary" role="tabpanel" aria-labelledby="nav-summary-tab">
        <div className="trademo-table-container pt-3">
          {!!props.currentUserPlan && props.currentUserPlan !== "" && !!props.currentPlanAccess && props.currentPlanAccess.is_analytics_tab === false ? (
            <Card className="upgrade-card">
              <Card.Body>
                <div className="container">
                  <div className="row">
                    <div className="col-auto">
                      <div>
                        <img src={UpgradeIcon} alt="..." className="img-fluid" />
                      </div>
                    </div>
                    <div className="col">
                      <p>Access quick Reports on the searched shipments</p>
                      <p>Upgrade to higher plan to use this feature</p>
                      <div className="d-block my-3">
                        <button type="button" className="btn btn-success tw-bg-secondary-green" onClick={(e) => props.upgradeNow(e)}>
                          Upgrade
                        </button>
                      </div>
                      <div className="d-block">
                        <img src={AnalyticsImg} alt="..." className="img-fluid" />
                      </div>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          ) : (
            <>
              {
                <Reports
                  currentKeyViewTrendItem={props.currentKeyViewTrendItem}
                  analyticsViewAllData={props.fetchSummaryViewAllData}
                  analyticsTrendsData={props.fetchSummaryTrendsData}
                  viewAllFinalSearchReqObj={props.viewAllFinalSearchReqObj}
                  hideViewAllModal={props.hideAnalyticsViewAllModal}
                  dropdownOptions={props.analyticDropdownOptions}
                  from={props.defaultData.analyticsCountryID}
                  tradeDirection={props.defaultData.countryTypeCode}
                  country={props.defaultData.countryCaps}
                  twoColumnMapping={props.defaultData.twoColumnMapping}
                  analyticsType={props.analyticsType}
                  userCredit={props.userCredit}
                  analyticsRangeDownloadPresent={props.defaultData.analyticsRangeDownloadPresent}
                  viewAllAPI={props.defaultData.apiEndPoints.getAnalyticsViewAll}
                  isViewAllGridNew={props.defaultData.isViewAllGridNew}
                  mapSelectedValue={(val) => props.mapSelectedValue(val)}
                  selectedRows={props.selectedRows}
                  defaultData={props.defaultData}
                  pathname={window.location.pathname}
                  analyticsCountryID={props.defaultData.analyticsCountryID}
                  currentUserPlan={props.currentUserPlan}
                  trendsAPI={props.defaultData.apiEndPoints.getAnalyticsViewAll}
                  handleClose={props.handleClose}
                  heading={props.modalHeading}
                  analyticsDataSource={(e) => props.getAnalyticsData("search", e)}
                  trendsDropdownOptions={props.trendsDropdownOptions}
                  analyticsItems={props.defaultData.analyticsFieldsMapping}
                  userDetails={props.userDetails}
                  viewReportFlag={props.viewReportFlag}
                />
              }
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(Report);
